import * as React from 'react';
import { Logging } from '@vcd-ecm-ui/Common';
import { VtxButton, VtxIcon } from '@vertexinc/vtx-ui-react-component-library';
import ColumnLinkProps from './ColumnLinkProps.interface';
import './column-link.scss';

const ColumnLink = ({
  id,
  icon,
  iconSize = 20,
  iconPlacement = 'left',
  linkText,
  linkAddress,
  linkTarget = '_self',
  onClick,
  row,
  align = 'left',
}: ColumnLinkProps): JSX.Element => {
  React.useEffect(() => {
    // This Code will run once after the initial Render
    if (linkAddress && onClick) {
      Logging.Warning(`ColumnLink '${id}': Only one of 'linkAddress' or 'onClick' should be specified.`);
    }

    if (!linkAddress && !onClick) {
      Logging.Warning(`ColumnLink '${id}': At least one of 'linkAddress' or 'onClick' should be specified.`);
    }

    if (!linkText && !icon) {
      Logging.Warning(`ColumnLink '${id}': At least one of 'linkText' or 'icon' should be specified.`);
    }

    return (): void => {
      // This Code will run once the component unmounts.
      Logging.Debug('Action Menu: Unmount');
    };
  }, []);

  return (
    <>
      {
        linkText
          ? (
            <div key={id} className={`columnLinkWithText align${align}`}>
              {
                icon && (iconPlacement === 'left')
                && (
                  <VtxIcon type={icon} fontSize={iconSize} className="columnLinkLeftIcon" />
                )
              }
              {
                linkText
                && (
                  <a className="columnLinkAnchor" href={linkAddress} target={linkTarget} onClick={(event) => (onClick ? onClick(row) : undefined)}>
                    {linkText}
                  </a>
                )
              }
              {
                icon && (iconPlacement === 'right')
                && (
                  <VtxIcon type={icon} fontSize={iconSize} className="columnLinkRightIcon" />
                )
              }
            </div>
          )
          : (
            <div key={id} className={`columnLinkIconOnly align${align}`}>
              <a href={linkAddress} target={linkTarget} onClick={(event) => (onClick ? onClick(row) : undefined)}>
                <VtxIcon type={icon} fontSize={iconSize} />
              </a>
            </div>
          )
      }
    </>
  );
};

export default ColumnLink;
